<template>
  <div>
<!--    <success-alert text="This is a success alert!" v-if="showSuccessAlert" />-->
<!--    <danger-alert text="This is a danger alert!" v-if="showDangerAlert" />-->

    <h1 class="my-3 text-2xl">Modals</h1>
    <div class="grid grid-cols-2 gap-0">
      <div>
        <primary-button text="General Modal" @click="modalIsOpen = true" />
      </div>
      <div>
        <danger-button text="Danger Modal" @click="dangerModalIsOpen = true" />
      </div>
    </div>
    <h1 class="my-3 text-2xl">
      Buttons
    </h1>
    <div class="grid grid-cols-4 gap-3">
      <primary-button text="Primary Button" />
      <secondary-button text="Secondary Button" />
      <neutral-button text="Neutral Button" />
      <danger-button text="Danger Button" />
    </div>
    <div class="my-3 text-2xl">
      <h1>Alerts</h1>
    </div>
    <div class="flex flex-row gap-2">
      <div>
        <primary-button text="Trigger Success Alert" v-on:click="handleSuccessAlert" />
      </div>
      <div>
        <danger-button text="Trigger Danger Alert" v-on:click="handleDangerAlert"></danger-button>
      </div>
    </div>
    <general-modal
        :open="modalIsOpen"
        title="General Modal From TestingPage"
        content="Testing Page General Modal Content"
        cancel-button-text="cancel"
        action-button-text="Perform"
        v-on:modal:cancel="modalIsOpen = false"
        v-on:modal:perform="handleModalPerform" />
    <danger-modal
        :open="dangerModalIsOpen"
        title="Danger Modal"
        content="Danger Modal Content Area"
        cancel-button-text="Cancel"
        action-button-text="Destructive Action"
        v-on:modal:cancel="dangerModalIsOpen = false"
        v-on:modal:perform="handleModalPerform" />

  </div>
  <h1 class="my-3 text-2xl">
    Template Editor
  </h1>
  <div>
<!--    <template-editor />-->
  </div>
</template>

<script>
import GravyModal from "@/components/Functional/Modal/GravyModal";
import { CheckIcon } from '@heroicons/vue/outline'
import GeneralModal from "@/components/Functional/Modal/GeneralModal";
import DangerModal from "@/components/Functional/Modal/DangerModal";
import PrimaryButton from "@/components/Functional/Buttons/PrimaryButton";
import DangerButton from "@/components/Functional/Buttons/DangerButton";
import SecondaryButton from "@/components/Functional/Buttons/SecondaryButton";
import NeutralButton from "@/components/Functional/Buttons/NeutralButton";
import SuccessAlert from "@/components/Functional/Alert/SuccessAlert";
import DangerAlert from "@/components/Functional/Alert/DangerAlert";
export default {
  name: "Testing",
  components: {
    DangerAlert,
    SuccessAlert,
    NeutralButton,
    SecondaryButton, DangerButton, PrimaryButton, DangerModal, GeneralModal, GravyModal, CheckIcon},
  data() {
    return {
      modalIsOpen: false,
      dangerModalIsOpen: false,
      showSuccessAlert: false,
      showDangerAlert: false
    }
  },
  methods: {
    handleModalPerform() {
      console.log('Modal perform event emitted')
    },
    handleSuccessAlert() {
     this.$store.dispatch('createAlert', {
       type: 'success',
       message: 'This is a success alert'
     })
    },
    handleDangerAlert() {
      this.$store.dispatch('createAlert', {
        type: 'danger',
        message: 'This is a danger alert'
      })
    }
  }
}
</script>

<style scoped>

</style>
